import axios from 'axios'

// import { app } from '@/main.js'
import { getSign } from '../utils/index'
export const TIMEOUT = 60 * 1000
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.timeout = TIMEOUT
const config = {
  // baseURL: process.env.VUE_APP_BASE_URL
  baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_URL
}
const _axios = axios.create(config)
function interceptors(axios) {
  axios.interceptors.request.use(
    config => {
      const exports = config.method === 'get' ? config.params : config.data
      const time = Math.floor(new Date().getTime() / 1000)
      const datalist = { ...exports }
      exports.time = time
      exports.sign = getSign(datalist, time)
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
  axios.interceptors.response.use(
    response => {
      if (response.status >= 200 && response.status < 399) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(response)
      }
    },
    error => {
      /* eslint-disable prefer-promise-reject-errors  */
      console.log('====error===', error)
      const { response } = error
      if (response) {
        return Promise.reject(response)
      } else {
        // if (!window.navigator.onLine) {
        // // 没连上网的处理
        //   var config = error.config
        //   config.retryCount = config.retryCount || 0
        //   if (config.retryCount >= config.retry) {
        //   // 提示网络异常
        //     return Promise.reject({
        //       requestCode: 7001,
        //       msg: '请求超时，请检查网络连接是否正常'
        //     })
        //   }
        //   // config.retryCount += 1
        //   // var backoff = new Promise((resolve) => {
        //   //   setTimeout(() => {
        //   //     resolve()
        //   //   }, config.retryDelay)
        //   // })
        //   // return backoff.then(() => {
        //   //   return axios(config)
        //   // })
        // } else {
        //   return Promise.reject(error)
        // }
        return Promise.reject(Promise.reject({
          requestCode: 7001,
          msg: '请求超时，请检查网络连接是否正常'
        }))
      }
    }
  )
}
interceptors(_axios)

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    _axios.get(url, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      if (err.requestCode) {
        // app.$toast(err.msg)
      }
      reject(err)
    })
  })
}
export function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    _axios.post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        if (err.requestCode) {
          // app.$toast(err.msg)
        }

        reject(err)
      })
  })
}
